module.exports = Promise.all([__parcel__import__("3wfzL"), __parcel__import__("8GMqS")]).then(() => parcelRequire('3pHq1'));